import LOGO from './logo.png'
import FAIL from './fail.png'
import PASS from './pass.png'

export const ICONS = { LOGO, PASS, FAIL }
